import { footerStyles as styles } from "@insite/content-library/Pages/Footer";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings, mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.page = {
    ...styles.page,
    css: css`
        position: relative;
        margin-top: 60px;

        &::before {
            content: "";
            border-top: 1px solid ${getColor(colorStrings.commonBorder)};
            position: absolute;
            top: 0;
            right: 0;
            left: 0;
            height: 1px;
            z-index: 1;
        }

        ${mediaQueriesBP.minXLG} {
            &::before {
                left: calc(((100vw - 100%) / 2) * -1);
                right: calc(((100vw - 100%) / 2) * -1);
            }
        }

        &&& {
            padding: 0;
        }

        .home-page-link {
            img {
                height: auto;
            }
        }

        /* Custom styles for the subscribe widget */
        .email-grid-item {
            .email-text-field {
                height: 30px;
                min-height: 30px;
                padding: 0 8px !important;
            }

            .email-button {
                min-height: 30px;
                height: 30px;
                padding: 0 16px;
                width: auto;
                display: flex;
                text-align: center;
                font-size: 16px;

                span {
                    min-width: fit-content;
                    padding: 0;
                    white-space: nowrap;
                    font-size: 16px;
                    line-height: 25px;
                }
            }
        }

        .disclaimer-grid-item {
            ${mediaQueriesBP.maxMD} {
                margin-bottom: 30px;
            }
        }

        /* Custom styles for the footer links */
        .list-wrapper {
            ${mediaQueriesBP.maxMD} {
                .title-wrapper {
                    h3 {
                        font-size: 18px;
                        color: ${getColor(colorStrings.textMain)};
                    }
                }
            }
        }
    `,
};